export const getImageUrl = (media) => {
    if(media.s320_url) {
        return media.s320_url
    } else if (media.s480_url) {
        return media.s480_url
    } else {
        return media.url
    }
}